// @flow
import type { StateType } from '../../reducers';
import type { TravelStateType } from './reducer';

const travelStateSelector = (state: StateType): ?TravelStateType => state.international.travel;

export const travelZoneSelector = (state: StateType): ?string => {
  const iddState = travelStateSelector(state);
  return iddState?.country?.travelZone;
};
